export default {
  1: { id: 1, title: 'Pending' },
  2: { id: 2, title: 'Approved' },
  3: { id: 3, title: 'Rejected' },
  4: { id: 4, title: 'Awaiting Parent Certification' },
  5: { id: 5, title: 'Under Review' },
  7: { id: 7, title: 'Certification Withdrawn' },
  8: { id: 8, title: 'Withdrawn' },
  10: { id: 10, title: 'Accepted' },
  11: { id: 11, title: 'Completed' },
  17: { id: 17, title: 'Saved' }
};



// WEBPACK FOOTER //
// ./src/dictionaries/RequestStatuses.js